import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { ContentCard } from '../components/ContentCard'
import { getContentsByType } from '../data/content'
import { useSeo } from '../hooks/useSeo'

export function SongsPage() {
  useSeo({
    title: 'பக்திப் பாடல்கள்',
    description: 'தெய்வீக ஓசை அசல் பக்திப் பாடல்கள் — வரிகள் மற்றும் பொருள்.',
    path: '/songs',
  })
  const songs = getContentsByType(['original-song'])

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'பக்திப் பாடல்கள்' }]} />
        <div className="section-header">
          <h1>பக்திப் பாடல்கள்</h1>
          <p>தெய்வீக ஓசை அசல் பாடல்கள் — YouTube-இல் கேளுங்கள், இங்கே வரிகளைப் படியுங்கள்.</p>
        </div>
        <div className="card-grid card-grid--3">
          {songs.map((item) => (
            <ContentCard key={item.id} item={item} />
          ))}
        </div>
        <p style={{ marginTop: '1.5rem' }}>
          <Link to="/stutis">பாரம்பரிய ஸ்துதிகளையும் பாருங்கள் →</Link>
        </p>
      </div>
    </div>
  )
}
